export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10175.ac9ac0fc.jpg";